import type { PropsWithChildren } from 'react';

import FullPageContent from '../box/FullPageContent';
import SupportForm from '@/client/features/mailboxes/SupportForm';

import Page, { type PageProps } from '@/components/layout/Page';
import { SUPPORT_SUBJECTS, SUPPORT_TYPES } from '@/client/features/mailboxes/types';
import { PREMIUM_TRIAL_DESCRIPTION } from '@/client/features/mailboxes/utils/premiumTrialRfi';

interface RFIPageUpsellProps extends PageProps {}

const RFIPageUpsell = ({ children, ...pageProps }: PropsWithChildren<RFIPageUpsellProps>) => (
  <Page
    noAccessRender={
      <FullPageContent>
        <SupportForm
          disabledFields={{ subject: true }}
          name="support-form"
          hideFields={{
            due_date: true,
          }}
          prefillData={{
            subject: SUPPORT_SUBJECTS.PREMIUM_TRIAL,
            description: PREMIUM_TRIAL_DESCRIPTION,
            due_date: new Date().toISOString().split('T')[0],
            to: SUPPORT_TYPES.SUPPORT,
          }}
          subjects={[SUPPORT_SUBJECTS.PREMIUM_TRIAL]}
        />
      </FullPageContent>
    }
    {...pageProps}
  >
    {children}
  </Page>
);

export default RFIPageUpsell;
